import { render, staticRenderFns } from "./FindingStatusChip.vue?vue&type=template&id=337e934a&scoped=true"
import script from "./FindingStatusChip.vue?vue&type=script&lang=ts"
export * from "./FindingStatusChip.vue?vue&type=script&lang=ts"
import style0 from "./FindingStatusChip.vue?vue&type=style&index=0&id=337e934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e934a",
  null
  
)

export default component.exports